import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { ContractorComponent } from './contractor.component';
import {
  ContractorRoutingModule,
  COMPONENTS,
} from './contractor-routing.module';
import { SwiperModule } from 'swiper/angular';
import {
  CompanyEditModalComponent,
  UploadDocumentModalComponent,
  CompanyNameModalComponent,
  CompanyDetailModalComponent,
  CompanyInfoModalComponent,
  CompanyPictureModalComponent,
  DocUploadModalComponent,
  DocUploadNewModalComponent,
  NewDirectorModalComponent,
  DirectorRecordModalComponent,
  InvoiceDetailModalComponent,
  TransactionDetailModalComponent,
  NewTccRecordModalComponent,
  YearRecordModalComponent,
  NewProfitRecordModalComponent,
  EditProfitRecordModalComponent,
  EditTccRecordModalComponent,
  NewEquipmentModalComponent,
  EditEquipmentModalComponent,
  RoleNewModalComponent,
  PaymentDetailModalComponent,
  uploadDocumentsModalComponent,
  ViewDocumentModalComponent,
  NewAOLModalComponent,
  LinkDocumentModalComponent,
  DeactivateWalletModalComponent,
  FundWalletModalComponent,
  RequestWithdrawalModalComponent,
  ViewDetailsModalComponent,
  ChangeBankDetailsModalComponent,
  CloseAccountModalComponent,
  ExportStatementByDateModalComponent,
  ActivateAccountModalComponent,
  ChatModalComponent,
  TAndCModalComponent,
  NewIndividualModalComponent,
  EditSharesModalComponent,
  NewCompanyModalComponent,
  EditDocumentnameModalComponent,
} from './modals';
import { CompanyDetailViewModalComponent } from './modals/company-detail-view-modal/company-detail-view-modal.component';
import { EditCompanyDetailModalComponent } from './modals/edit-company-detail-modal/edit-company-detail-modal.component';
import { ArchivedDocumentComponent } from './components/registered-company/company-document/archived-document/archived-document.component';
import { OfficialDocumentComponent } from './components/registered-company/company-document/official-document/official-document.component';
import { DocumentTypeModalComponent } from './modals/document-type-modal/document-type-modal.component';
import { ViewHistoryModalComponent } from './modals/view-history-modal/view-history-modal.component';
import { OfficialEquipmentComponent } from './components/registered-company/company-equipment/official-equipment/official-equipment.component';
import { ArchivedEquipmentComponent } from './components/registered-company/company-equipment/archived-equipment/archived-equipment.component';
import { CompanyShareholderComponent } from './components/registered-company/company-shareholder/company-shareholder.component';
import { CompanyPersonnelComponent } from './components/registered-company/company-personnel/company-personnel.component';
import { NewPersonnelModalComponent } from './modals/new-personnel-modal/new-personnel-modal.component';
import { NgxFilterModule } from '../ngx-filter/filter.module';
import { NewAssessmentModalComponent } from './modals/network-assessment/new-assessment-component-modal';
import { ViewAssessmentModalComponent } from './modals/view-assessment-modal/view-assessment-modal.component';
import { NonNewAssessmentModalComponent } from './modals/non-network-assessment/non-new-assessment-component-modal';
import { ViewNonAssessmentModalComponent } from './modals/view-non-assessment-modal/view-non-assessment-modal.component';
import { uploadAolDocumentsModalComponent } from './modals/upload-aol-document/upload-aol-documents-modal';
import { EditCompanyCeoInfoModalComponent } from './modals/edit-company-ceo-info-modal/edit-company-ceo-info-modal.component';
import { ViewDepositSlipModalComponent } from './modals/view-deposit-slip-modal/view-deposit-slip-modal.component';
import { ChatViewComponent } from './modals/chat-modal/chat-view/chat-view.component';
import { AllConversationsComponent } from './components/chat-window/all-conversations/all-conversations.component';
import { ConversationComponent } from './components/chat-window/all-conversations/conversation/conversation.component';
import { ConversationViewComponent } from './components/chat-window/conversation-view/conversation-view.component';
import { NewChatModalComponent } from './modals/new-chat-modal/new-chat-modal.component';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { ConversationScreenComponent } from './components/chat-window/conversation-screen/conversation-screen.component';
import { ChatMessagesComponent } from './components/chat-window/chat-messages/chat-messages.component';
import { PendingTransactionsRowComponent } from './components/e-wallet/transactions/pending-transactions-row/pending-transactions-row.component';
import { ViewPendingDetailsComponent } from './modals/view-pending-details/view-pending-details.component';
import {
  CompanyOwnershipStructureComponent,
  DirectorsUpdateModeComponent,
  HistoryStructureComponent,
  PendingStructureComponent,
  VerifiedStructureComponent,
} from './components';
import { SupportingDocumentsComponent } from './components/registered-company/supporting-documents/supporting-documents.component';
import { OfficalSupportingDocumentsComponent } from './components/registered-company/supporting-documents/offical-supporting-documents/offical-supporting-documents.component';
import { OfficalSupportingDocumentsListComponent } from './components/registered-company/supporting-documents/offical-supporting-documents/offical-supporting-documents-list/offical-supporting-documents-list.component';
import { OtherTccRecordModalComponent } from './modals/other-tcc-record-modal/other-tcc-record-modal.component';
import { EditOtherTccModalComponent } from './modals/edit-other-tcc-modal/edit-other-tcc-modal.component';
import { PermissionGuard } from './guard/permission.guard';

const ENTRY_COMPONENT: Array<any> = [
  CompanyEditModalComponent,
  UploadDocumentModalComponent,
  NewAssessmentModalComponent,
  CompanyNameModalComponent,
  CompanyDetailModalComponent,
  CompanyInfoModalComponent,
  CompanyPictureModalComponent,
  DocUploadModalComponent,
  DocUploadNewModalComponent,
  NewDirectorModalComponent,
  DirectorRecordModalComponent,
  InvoiceDetailModalComponent,
  TransactionDetailModalComponent,
  NewTccRecordModalComponent,
  YearRecordModalComponent,
  NewProfitRecordModalComponent,
  EditProfitRecordModalComponent,
  EditTccRecordModalComponent,
  NewEquipmentModalComponent,
  EditEquipmentModalComponent,
  RoleNewModalComponent,
  PaymentDetailModalComponent,
  uploadDocumentsModalComponent,
  ViewAssessmentModalComponent,
  NonNewAssessmentModalComponent,
  ViewNonAssessmentModalComponent,
  uploadAolDocumentsModalComponent,
  ViewDocumentModalComponent,
  NewAOLModalComponent,
  LinkDocumentModalComponent,
  DeactivateWalletModalComponent,
  FundWalletModalComponent,
  RequestWithdrawalModalComponent,
  ViewDetailsModalComponent,
  ChangeBankDetailsModalComponent,
  CloseAccountModalComponent,
  ExportStatementByDateModalComponent,
  ActivateAccountModalComponent,
  ChatModalComponent,
  NewIndividualModalComponent,
  EditSharesModalComponent,
  NewCompanyModalComponent,
  EditDocumentnameModalComponent,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ContractorComponent,
    ...ENTRY_COMPONENT,
    CompanyDetailViewModalComponent,
    EditCompanyDetailModalComponent,
    ArchivedDocumentComponent,
    OfficialDocumentComponent,
    CompanyShareholderComponent,
    DocumentTypeModalComponent,
    ViewHistoryModalComponent,
    OfficialEquipmentComponent,
    ArchivedEquipmentComponent,
    CompanyPersonnelComponent,
    NewPersonnelModalComponent,
    NewAssessmentModalComponent,
    ViewAssessmentModalComponent,
    NonNewAssessmentModalComponent,
    ViewNonAssessmentModalComponent,
    uploadAolDocumentsModalComponent,
    ViewDocumentModalComponent,
    NewAOLModalComponent,
    LinkDocumentModalComponent,
    EditCompanyCeoInfoModalComponent,
    ViewDepositSlipModalComponent,
    TAndCModalComponent,
    ChatViewComponent,
    AllConversationsComponent,
    ConversationComponent,
    ConversationViewComponent,
    NewChatModalComponent,
    ChatWindowComponent,
    ConversationScreenComponent,
    ChatMessagesComponent,
    PendingTransactionsRowComponent,
    ViewPendingDetailsComponent,
    CompanyOwnershipStructureComponent,
    VerifiedStructureComponent,
    PendingStructureComponent,
    HistoryStructureComponent,
    DirectorsUpdateModeComponent,
    SupportingDocumentsComponent,
    OfficalSupportingDocumentsComponent,
    OfficalSupportingDocumentsListComponent,
    OtherTccRecordModalComponent,
    EditSharesModalComponent,
    NewCompanyModalComponent,
    EditDocumentnameModalComponent,
    EditOtherTccModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContractorRoutingModule,
    SwiperModule,
    NgxFilterModule,
  ],
  providers: [PermissionGuard],
  entryComponents: [...ENTRY_COMPONENT],
})
export class ContractorModule {}
